import _ from 'lodash';
import { makeCell } from './gridUtill';
import pdfIcon from '../../assets/img/icon_pdf.png';

let fields = [];
let columns = [];
const data = [
  {
    field: 'lotNo',
    alias: 'Lot No',
    width: 120,
  },
  {
    field: 'code',
    alias: 'Code Grade',
    width: 120,
  },
  {
    field: 'pick_name',
    alias: '수령자',
    width: 100,
  },
  {
    field: 'request_company',
    alias: '수령업체명',
    width: 150,
  },
  {
    field: 'email',
    alias: '수신자 메일',
    width: 200,
  },
  {
    field: 'gubun',
    alias: '구분',
    width: 80,
  },
  {
    field: 'send_status',
    alias: '발송상태',
    width: 100,
  },
  {
    field: 'send_dt',
    alias: '발송일시',
    width: 150,
    renderer: {
      type: 'html',
      callback: function (grid, cell) {
        const val = grid.getValue(cell.index.itemIndex, 'send_dt');
        if (val && val.length >= 16) {
          return val.substring(0, 16);
        }
        return val || '-';
      },
    },
  },
  {
    field: 'fail_reason',
    alias: '실패사유',
    width: 200,
  },
  {
    field: 'send_type',
    alias: '타입',
    width: 100,
  },
  {
    field: 'file_path',
    alias: 'visible_path',
    width: 0,
  },
  {
    field: 'mail_content',
    alias: 'visible_mail',
    width: 0,
  },
  {
    field: 'has_file',
    alias: '다운로드',
    width: 50,
    urlCallback: true,
  },
  {
    field: 'has_content',
    alias: '내용보기',
    width: 50,
    urlCallback: true,
  },
];

_.each(data, function (o) {
  o.indexExclusive = true;

  if (o.urlCallback) {
    makeCell(1, [o], fields, columns, 10, null, {
      type: 'html',
      callback: function (grid, cell) {
        if (cell.valueColumn.fieldName === 'has_file') {
          const val = grid.getValue(cell.index.itemIndex, 'file_path');
          return val ? `<div class="icons" style="cursor: pointer;"><img src="${pdfIcon}" alt="download icon" /></div>` : '-';
        } else if (cell.valueColumn.fieldName === 'has_content') {
          const val = grid.getValue(cell.index.itemIndex, 'mail_content');
          return val ? `<div style="cursor: pointer; color: #00694D; text-decoration: underline; font-weight: bold;">내용보기</div>` : '-';
        }
      },
    });
  } else {
    makeCell(1, [o], fields, columns);
  }
});

export { fields, columns };
